import { createContext, useState } from 'react'

export const SettingsTimeContext = createContext(undefined)

export const SettingsTimeContextProvider = ({ children }) => {
	const [editedCells, setEditedCells] = useState([])

	return <SettingsTimeContext.Provider value={{ editedCells, setEditedCells }}>{children}</SettingsTimeContext.Provider>
}
